import { Component, Input } from '@angular/core';
import { ComprehensiveService } from '../../core/dto/comprehensive-service.interface';
import { LanguageService } from '../../core/services/language.service';

@Component({
  selector: 'app-comprehensive-service',
  templateUrl: './comprehensive-service.component.html',
  styleUrls: ['./comprehensive-service.component.scss']
})
export class ComprehensiveServiceComponent {
  constructor(private readonly languageService: LanguageService) { }

  @Input() service!: ComprehensiveService

  isExternal(link: string): boolean {
    return /^https?:\/\//i.test(link);
  }

  getRouterLink(path: string): any[] {
    const cleanPath = (path || '').replace(/^\/+|\/+$/g, '');
    const segments = cleanPath ? cleanPath.split('/').filter(Boolean) : [];
    const lang = this.languageService.lang;
    return ['/', ...segments, lang];
  }
}
